import { ComponentProps, forwardRef } from 'react';
import { Platform } from 'react-native';
import { View } from 'native-base';

export type StoreReportViewerSource = { uri?: string };

type StoreReportViewerProps = {
  _container?: ComponentProps<typeof View>;
  source?: StoreReportViewerSource;
  onLoad?: (_props: StoreReportViewerSource) => void;
};

// Forward ref to either iframe (web) or WebView (native)
export const StoreReportViewer = forwardRef<HTMLIFrameElement, StoreReportViewerProps>(({ _container, source, ..._props }, ref) => {
  const handleLoad = () => {
    if (!source?.uri) return;
    _props.onLoad?.({ uri: source.uri });
  };

  return (
    <View w="full" h="full" {..._container}>
      {Platform.OS === 'web' ? (
        <iframe
          ref={ref}
          style={{
            borderWidth: 0,
            height: '100%',
            width: '100%',
            backgroundColor: 'white',
          }}
          src={source?.uri ? `${source.uri}#view=FitV&zoom=page-fit` : undefined}
          onLoad={handleLoad}
        />
      ) : (
        <View ref={ref} w="full" h="full" />
      )}
    </View>
  );
});
